import React from 'react';
import { Loading } from '@/components/utils/Loading';

export const AuthGateway: React.FC = () => {
  return <Loading />;
};
